module.exports = require("lodash/without");